"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessfulStreemshot = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const room_session_1 = require("../../context/room_session");
const sdk_core_1 = require("@streem/sdk-core");
function SuccessfulStreemshot() {
    const animationDuration = 1500;
    const roomSession = (0, room_session_1.useRoomSession)();
    const nukeLatestStreemshot = (0, react_1.useMemo)(() => new rxjs_1.Subject(), []);
    const [latestStreemshot, setLatestStreemshot] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        /**
         * Listens for the latest streemshot and sets it in component state
         * It also kicks off a timer to remove the latest streemshot
         */
        let setLatestStreemshotSub;
        if ((0, sdk_core_1.isHostRoomSession)(roomSession)) {
            setLatestStreemshotSub = roomSession.streemshots.latestRequest.subscribe(() => {
                nukeLatestStreemshot.next(undefined);
                setLatestStreemshot({ downloadUrl: '' });
            });
        }
        else {
            setLatestStreemshotSub = roomSession.streemshots.latestResponse.subscribe(streemshot => {
                var _a;
                nukeLatestStreemshot.next(undefined);
                setLatestStreemshot({ downloadUrl: (_a = streemshot.downloadUrl) !== null && _a !== void 0 ? _a : '' });
            });
        }
        /**
         * Listens for a signal and starts a timer.
         * When timer completes, sets the latest streemshot to undefined.
         */
        const nukeLatestStreemshotSub = nukeLatestStreemshot
            .pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.timer)(animationDuration)))
            .subscribe(() => {
            setLatestStreemshot(undefined);
        });
        return () => [setLatestStreemshotSub, nukeLatestStreemshotSub].forEach(sub => sub.unsubscribe());
    }, [nukeLatestStreemshot, roomSession]);
    if (latestStreemshot &&
        ((0, sdk_core_1.isSpectatorRoomSession)(roomSession) || (0, sdk_core_1.isOnSiteRoomSession)(roomSession))) {
        return ((0, jsx_runtime_1.jsx)(ui_react_1.AnimatedImage, { animationDuration: animationDuration, src: latestStreemshot.downloadUrl }));
    }
    else if (latestStreemshot && (0, sdk_core_1.isHostRoomSession)(roomSession)) {
        return (0, jsx_runtime_1.jsx)(ui_react_1.AnimatedStreemshotCamera, { animationDuration: animationDuration });
    }
    else {
        return null;
    }
}
exports.SuccessfulStreemshot = SuccessfulStreemshot;
//# sourceMappingURL=successful_streemshot.js.map